import { Image, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { IMAGE_BASE_URL } from '../../../helper/variables'

const StoreCard = ({ item }) => {
    return (
        <VStack space='2' w={'fit-content'}
            bg='#cfcfcf4D'
            borderRadius='md'
            py='2' px='2' h='44' mb='4'
        >
            <Image w={'52'} h={'32'} borderRadius='md' objectFit={'contain'}
                src={`${IMAGE_BASE_URL}${item.store_images?.[0]}`} alt="image base" />
            <Text textAlign={'center'} fontSize='sm' fontWeight='normal'>{item.store_name}</Text>
        </VStack>
    )
}

export default StoreCard